export default __webpack_public_path__ + "static/media/email.c94e1350.png";